import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-react-context/pkg/MobileContext';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';
import WidgetPaywall from '../_partials/paywalls/WidgetPaywall';
import useModuleData from '../../../../utils/hooks/useModuleData';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import reduxConnectContainerCustom from '../Custom/Custom.container';
import reduxConnectContainer from './MegaboxBox.container';
import Custom, { Props } from '../Custom/Custom';

import s from './MegaboxBox.scss';

const Edit = lazy(() => import(/* webpackChunkName: "owner" */ './Edit'));

const enhance = compose(
  withMobileContext,
  reduxConnectContainer,
  reduxConnectContainerCustom
);
export const MegaboxBox: React.FC<
  Props & WidgetBoxProps & WithMobileContextProps
> = props => {
  const {
    title,
    moduleId,
    widgetMoveUp,
    widgetRemove,
    widgetMoveDown,
    widgetAddColumn,
    widgetBoxClassName,
    direction,
    section,
    zone,
    position,
    viewerKeySuffix,
    showCoreUpsell,
  } = props;
  const { t } = useTranslation();
  const {
    moduleData: { width },
  } = useModuleData<{ width: number }>(moduleId);

  const renderEditMenu = closeMenu => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <Edit
          moduleId={moduleId}
          onRequestClose={closeMenu}
          widgetRemove={widgetRemove}
        />
      </Suspense>
    );
  };

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={moduleId}
      header={title}
      autoShowWidgetConfig={true}
      widgetMenuRenderer={closeMenu => renderEditMenu(closeMenu)}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      widgetAddColumn={widgetAddColumn}
      className={classnames(
        widgetBoxClassName,
        s[width],
        showCoreUpsell && s['locked']
      )}
      editControlsTooltipContent={
        showCoreUpsell && t('widgets.custombox.edit.tooltip')
      }
      direction={direction}
    >
      <ConditionalWrapper
        condition={showCoreUpsell}
        wrap={child => <WidgetPaywall>{child}</WidgetPaywall>}
      >
        <Custom
          {...props}
          zone={zone}
          position={position}
          viewerKeySuffix={viewerKeySuffix}
          noPadding
        />
      </ConditionalWrapper>
    </WidgetBox>
  );
};

MegaboxBox.displayName = 'MegaboxBox';

export default enhance(MegaboxBox);
